<template>
  <div class="body-container">
    <h2><span class="mdi mdi-account mdi-36px"></span>アクションの設定</h2>
    <!-- ローディング画面 -->
    <div style="position: fixed; z-index: 100; width: 100vw; height: 100vh; background: white; top: 0;" v-if="isEmailActionLoading">
      <Loading/>
    </div>
    <!-- エラーの場合 -->
    <div v-if="!isEmailActionLoading&&(isEmailActionError||!emailAction)">
      <p>
        URL情報が不正のため、ページが読み込めませんでした。<br>
        EmailからのURLをご確認の上、アクセスをお願いいたします。
      </p>
    </div>
    <!-- 正常に読み込んだ場合 -->
    <template v-if="!isEmailActionError&&!isEmailActionLoading&&emailAction">
      <!-- 応募時 -->
      <template v-if="emailAction.action_history.recruit_status === 0">
        <div style="padding: 16px; border: solid thin #ccc; border-radius: 8px; text-align: left;">
          <!-- 合格・不合格ページ - 未アクション -->
          <template v-if="emailAction.action_history.action_status != 9">
          <p v-if="$route.query.status === 'pass'">
            応募後のアクションを<b style="color: red;">合格</b>に設定します。<br>
            下記、日程調整メールを{{emailAction.seeker.name}}様へお送りいたしますがよろしいでしょうか？<br>
            ※「いいえ」を選択するとページを一度閉じます。
          </p>
          <p v-if="$route.query.status === 'failure'">
            応募後のアクションを<b style="color: red;">不合格</b>に設定します。<br>
            下記、不合格通知メールを{{emailAction.seeker.name}}様へお送りいたしますがよろしいでしょうか？<br>
            ※「いいえ」を選択するとページを一度閉じます。
          </p>
          <div v-if="$route.query.status === 'pass'">
            <p>
              下記の日程調整ロボを応募者にお送りします。<br>
              選択されていない場合は、設定をお願いいたします。
            </p>
            <div style="padding: 8px;">
              次の選考を選択：
              <select class="select" v-model="nextStage">
                <option v-for="(stg, stgIdx) in emailAction.stages" :key="stgIdx" :value="stg.id">
                  {{stg.name}}
                </option>
              </select>
            </div>
            <div style="padding: 8px;">
              日程調整ロボの選択：
              <select class="select" v-model="newChatBot">
                <option v-for="(cb, idx) in emailAction.chatbots" :key="idx" :value="cb.bot_id">
                  {{cb.name}}
                </option>
              </select>
            </div>
          </div>
          <div style="display: flex; justify-content: center;">
            <button @click="createFromEmailActionHistory()" class="button is-primary" style="margin-right: 8px;">は　い</button>
            <button @click="closePage()" class="button is-danger">いいえ</button>
          </div>
          </template>
          <template v-else>
            <p>既に{{emailAction.seeker.name}}様について不採用と設定済みです。</p>
            <button class="button is-danger" @click="closePage()">閉じる</button>
          </template>
        </div>
      </template>
      <!-- 応募者日程選択前 -->
      <template v-if="emailAction.action_history.recruit_status === 1">
        <div style="padding: 16px; border: solid thin #ccc; border-radius: 8px; text-align: left;">
          現在{{emailAction.seeker.name}}様に、Emailにて、日程の調整をご依頼中です。<br>
          仮登録が完了するまで、今しばらくお待ちください。<br><br>
          <button class="button is-danger" @click="closePage()">閉じる</button>
        </div>
      </template>
      <!-- 応募者日程選択（仮） -->
      <template v-if="emailAction.action_history.recruit_status === 2">
        <div style="padding: 16px; border: solid thin #ccc; border-radius: 8px; text-align: left;">
          <p v-if="$route.query.status === 'scheduled'">
            {{emailAction.seeker.name}}様から頂いた、下記日付でよろしいでしょうか？<br>
            よろしければ「はい」を選択してください。<br>
            ※「いいえ」を選択するとページを一度閉じます。<br>
          </p>
          <p v-else>
            {{emailAction.seeker.name}}様へ、下記日付を再調整するよう依頼致します。<br>
            よろしければ「はい」を選択してください。<br>
            ※「いいえ」を選択するとページを一度閉じます。<br>
          </p>
          <div style="text-align: center; color: red; font-weight: 600; padding: 8px; margin: 8px; border-radius: 4px; border: solid thin #ccc;">
            {{new Date(emailAction.action_history.interview_date).toLocaleString('ja-JP')}}
          </div>
          <div style="padding: 8px;" v-if="$route.query.status === 're_schedule'">
            日程調整ロボの選択：
            <select class="select" v-model="newChatBot">
              <option v-for="(cb, idx) in emailAction.chatbots" :key="idx" :value="cb.bot_id">
                {{cb.name}}
              </option>
            </select>
          </div>
          <div style="display: flex; justify-content: center;">
            <button @click="createFromEmailActionHistory()" class="button is-primary" style="margin-right: 8px;">は　い</button>
            <button @click="closePage()" class="button is-danger">いいえ</button>
          </div>
        </div>
      </template>
      <!-- 応募者日程選択（再調整） -->
      <template v-if="emailAction.action_history.recruit_status === 3">
        <div style="padding: 16px; border: solid thin #ccc; border-radius: 8px; text-align: left;">
          <p>{{emailAction.seeker.name}}様に再調整の依頼中です。</p>
          <button class="button is-danger" @click="closePage()">閉じる</button>
        </div>
      </template>
      <!-- 応募者日程調整後 -->
      <template v-if="emailAction.action_history.recruit_status === 4 || emailAction.action_history.recruit_status === 5">
        <div style="padding: 16px; border: solid thin #ccc; border-radius: 8px; text-align: left;">
          <p>{{emailAction.seeker.name}}様との日程調整は完了しました。</p>
          <button style="margin: 8px;" class="button is-danger" @click="closePage()">閉じる</button>
        </div>
      </template>
      <!-- 応募者日程調整後 -->
      <template v-if="emailAction.action_history.recruit_status === 6">
        <div style="padding: 16px; border: solid thin #ccc; border-radius: 8px; text-align: left;">
          <!-- 選考通過 -->
          <template v-if="$route.query.status === 'pass'">
            <p style="margin-bottom: 8px;">
              {{emailAction.seeker.name}}様を次の選考へと進めたいと思います。<br>
              次の選考を選択し、「確認」ボタンを押下してください。<br>
              ※「閉じる」を選択するとページを一度閉じます。<br>
            </p>
            <div style="padding: 8px;">
              次の選考を選択：
              <select class="select" v-model="nextStage">
                <option v-for="(stg, stgIdx) in emailAction.stages" :key="stgIdx" :value="stg.id">
                  {{stg.name}}
                </option>
              </select>
            </div>
            <div style="padding: 8px;">
              日程調整ロボの選択：
              <select class="select" v-model="newChatBot">
                <option v-for="(cb, idx) in emailAction.chatbots" :key="idx" :value="cb.bot_id">
                  {{cb.name}}
                </option>
              </select>
            </div>
            <div style="display: flex; justify-content: center;">
              <button @click="createFromEmailActionHistory()" class="button is-primary" style="margin-right: 8px;">確認</button>
              <button class="button is-danger" @click="closePage()">閉じる</button>
            </div>
          </template>
          <!-- 不採用 -->
          <template v-else>
            <p style="margin-bottom: 8px;">
              アクションを<b style="color: red;">不合格</b>に設定します。<br>
              下記、不合格通知メールを{{emailAction.seeker.name}}様へお送りいたしますがよろしいでしょうか？<br>
              ※「いいえ」を選択するとページを一度閉じます。
            </p>
            <div style="display: flex; justify-content: center;">
              <button @click="createFromEmailActionHistory()" class="button is-primary" style="margin-right: 8px;">は　い</button>
              <button @click="closePage()" class="button is-danger">いいえ</button>
            </div>
          </template>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex"
import Loading from '@/components/animations/Loading'
export default {
  name: "EmailAction",
  componentName: "EmailAction",
  components: {
    Loading
  },
  computed: {
    ...mapState('directtalk', ['emailAction', 'isEmailActionLoading', 'isEmailActionError'])
  },
  data () {
    return {
      newChatBot: null,
      nextStage: null,
      finished_step: false
    }
  },
  mounted () {
    this.$store.dispatch('directtalk/getEmailAction', {
      id: this.$route.query.id,
      action: this.$route.query.action,
      status: this.$route.query.status
    })
  },
  watch: {
    isEmailActionLoading () {
      if (!this.isEmailActionLoading) {
        this.newChatBot = this.emailAction.action.chatbots_id
        for (let i in this.emailAction.stages) {
          if (this.emailAction.seeker.recruitment_flow_stage_id === this.emailAction.stages[i].id) {
            this.nextStage = this.emailAction.stages.length > Number(i + 1) ? this.emailAction.stages[Number(i + 1)].id : this.emailAction.stages[i].id
            break
          }
        }
      }
    } 
  },
  methods: {
    createFromEmailActionHistory () {
      if (this.$route.query.action === 'subscribe') {
        // 応募時
        let createData = null
        if (this.$route.query.status === 'pass') {
          // 値が入っているか確認
          if (!this.newChatBot || !this.nextStage) {
            alert('日程調整ロボ、もしくは次の選考について選択されておりません。\n選択後再度ボタンを押下してください。')
            return
          }
          createData = {
            select_bot: this.newChatBot,
            next_stage: this.nextStage,
            is_new: true, // 新規応募かどうか
            action_history: {
              seeker: this.emailAction.seeker.id,
              action: this.emailAction.action_history.action_id,
              recruit_status: 1,
              action_status: 1,
              finished_status: 0,
              is_finished: false
            }
          }
        } else {
          createData = {
            select_bot: this.newChatBot,
            is_new: true, // 新規応募かどうか
            action_history: {
              seeker: this.emailAction.seeker.id,
              action: this.emailAction.action_history.action_id,
              recruit_status: 0,
              action_status: 9,
              finished_status: 1,
              is_finished: true
            }
          }
        }
        this.$store.dispatch('directtalk/createFromEmailActionHistory', createData)
      } else if (this.$route.query.action === 'interview_date') {
        // 日程調整確定前
        let createData = null
        let ids = []
        for (let u of this.emailAction.interviewer) {
          ids.push(u.uuid)
        }
        if (this.$route.query.status === 'scheduled') {
          createData = {
            action_history: {
              seeker: this.emailAction.seeker.id,
              action: this.emailAction.action_history.action_id,
              interview_date: this.emailAction.action_history.interview_date,
              interviewer: ids,
              recruit_status: 4,
              action_status: 1,
              finished_status: 0,
              is_finished: false
            }
          }
        } else {
          // 値が入っているか確認
          if (!this.newChatBot) {
            alert('日程調整ロボについて選択されておりません。\n選択後再度ボタンを押下してください。')
            return
          }
          createData = {
            select_bot: this.newChatBot,
            action_history: {
              seeker: this.emailAction.seeker.id,
              action: this.emailAction.action_history.action_id,
              recruit_status: 3,
              action_status: 1,
              finished_status: 1,
              is_finished: false
            }
          }
        }
        this.$store.dispatch('directtalk/createFromEmailActionHistory', createData)
      } else if (this.$route.query.action === 'next_step') {
        let createData = null
        if (this.$route.query.status === 'pass') {
          // 値が入っているか確認
          if (!this.newChatBot || !this.nextStage) {
            alert('日程調整ロボ、もしくは次の選考について選択されておりません。\n選択後再度ボタンを押下してください。')
            return
          }
          // 面接終了後
          createData = {
              next_stage: this.nextStage,
              select_bot: this.newChatBot,
              is_new: false, // 新規応募かどうか
              action_history: {
                seeker: this.emailAction.seeker.id,
                action: this.emailAction.action_history.action_id,
                recruit_status: 1,
                action_status: 1,
                finished_status: 0,
                is_finished: false
              }
          }
          this.$store.dispatch('directtalk/createFromEmailActionHistory', createData)
        } else {
          createData = {
            next_stage: this.nextStage,
            select_bot: this.newChatBot,
            is_new: false, // 新規応募かどうか
            action_history: {
              seeker: this.emailAction.seeker.id,
              action: this.emailAction.action_history.action_id,
              recruit_status: 0,
              action_status: 9,
              finished_status: 1,
              is_finished: true
            }
          }
          this.$store.dispatch('directtalk/createFromEmailActionHistory', createData)
        }
      }
    },
    closePage () {
      window.close()
    }
  }
};
</script>

<style scoped>
.body-container {
  background: #fbfbfb;
  width: 100vw;
  height: 100vh;
  text-align: center;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
}
h2 {
  font-size: 24px;
  font-weight: 600;
  padding: 40px 20px;
}
h2 > span {
  margin-right: 10px;
}
.edit-box {
  width: 90%;
  max-width: 700px;
  height: 500px;
  border: solid thin #ccc;
}
.edit-column {
  width: 70%;
  max-width: 400px;
  min-width: 250px;
  margin: 15px auto;
}
.img-icon {
  width: 120px;
  height: 120px;
  object-fit: cover;
  background: #FEFEFE;
}
.left-in {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.right-bt {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Email/EmailAction.vue